import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  ClipboardList,
  ChevronRight
} from 'lucide-react';

const ArthikReportDashboard = () => {
  const navigate = useNavigate();

  const reports = [
    { id: 'namuna-1', title: 'नमुना १ (अंदाजपत्रक)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-2', title: 'नमुना २ (पुनर्विनियोजन अंदाजपत्रक)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-3', title: 'नमुना ३ (जमा व खर्च)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-4', title: 'नमुना ४ (पंचायतीचे भत्ते व दायित्वे)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-5k', title: 'नमुना ५ क (दैनिक रोकड वही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-5', title: 'नमुना ५ (सामान्य रोकड वही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-6', title: 'नमुना ६ (महिन्याचे वर्गीकरण)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-7', title: 'नमुना ७ (सामान्य पावती)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-11', title: 'नमुना ११ (किरकोळ मागणी नोंद वही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-12', title: 'नमुना १२ (आकस्मिक खर्चाचे प्रमाणक)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-13', title: 'नमुना १३ (कर्मचारी वर्गाची सूची व वेतनश्रेणी नोंद वही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-14', title: 'नमुना १४ (मुद्रांक हिशोब नोंद वही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-15', title: 'नमुना १५ (उपभोग वस्तू साठी लेखा नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-16', title: 'नमुना १६ (जड वस्तु संग्रह किंवा जंगम मालमत्ता नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-17', title: 'नमुना १७ (अग्रिम दिलेल्या/अनागत ठेवलेल्या रकमांची नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-18', title: 'नमुना १८ (किरकोळ रोकल वही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-19', title: 'नमुना १९ (कामावर असलेल्या व्यक्तींचा हजेरीपट)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-20', title: 'नमुना २० (कामाच्या अंदाजाची नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-20k', title: 'नमुना २० क (मोजमाप वही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-20kh', title: 'नमुना २० ख (कामाचे देयक)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-21', title: 'नमुना २१ (कर्मचा-यांच्या वेतन देयकांची नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-22', title: 'नमुना २२ (स्थावर मालमत्ता नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-23', title: 'नमुना २३ (ताब्यातील रस्त्यांची नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-24', title: 'नमुना २४ (जमिनीची नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-25', title: 'नमुना २५ (गुंतवणूक नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-26k', title: 'नमुना २६ क (जगा खर्चाचे मासिक विवरण)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-26kh', title: 'नमुना २६ ख (मासिक खर्चाचे विवरण)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-27', title: 'नमुना २७ (लेखापरिक्षणातील आक्षेपांच्या पुर्ततेचे मासिक विवरण)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-28', title: 'नमुना २८ (मागासवगीर्प १५% व महिला बाल कल्याण १०% खर्चाचे मासिक विवरण)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-29', title: 'नमुना २९ (कर्जाची नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-30', title: 'नमुना ३० (ग्रामपंचायत लेखापरिक्षण आक्षेप पुर्तता नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-31', title: 'नमुना ३१ (प्रवास भत्ता देयक)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-32', title: 'नमुना ३२ (रकमेच्या परताव्यासाठी आदेश)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'namuna-33', title: 'नमुना ३३ (वृक्ष नोंदवही)', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'khate-pustika', title: 'खाते पुस्तिका', icon: <ClipboardList className="w-8 h-8" /> },
    { id: 'mahine-jama-kharcha', title: 'महिन्याचा जमा व खर्च', icon: <ClipboardList className="w-8 h-8" /> },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">आर्थिक रिपोर्ट</h1>
            <p className="text-slate-300">
              Grampanchayat Reports Dashboard
            </p>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm flex items-center gap-2"
          >
            <ArrowLeft size={16} />
            मागे जा
          </button>
        </div>
      </div>

      {/* Reports Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reports.map((report) => (
          <div
            key={report.id}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 p-6 border-l-4 border-rose-500 cursor-pointer group flex items-center justify-between"
            onClick={() => {
                // Navigate to specific report page if available, else standard placeholder
                // navigate(`/report/${report.id}`); 
                console.log(`Clicked ${report.title}`);
            }}
          >
            <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 group-hover:bg-rose-600 group-hover:text-white transition-colors duration-300">
                  {report.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-rose-700 transition-colors">
                  {report.title}
                </h3>
            </div>
            <ChevronRight className="text-gray-400 group-hover:text-rose-600 transform group-hover:translate-x-1 transition-all" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArthikReportDashboard;
